module.exports = __webpack_public_path__ + "static/media/task.7aa63e01.png";